import {
  DELETE_SR_DOCUMENT_SUBTYPE,
  ERROR_SR_DOCUMENT_SUBTYPE,
  SET_SR_DOCUMENT_SUBTYPES,
  SET_SR_DOCUMENT_SUBTYPE_OPTIONS,
  TOGGLE_SR_DOCUMENT_SUBTYPE,
  UNSET_SR_DOCUMENT_SUBTYPE_ACTION,
  UNSET_SR_DOCUMENT_SUBTYPE_OPTIONS,
  UNSET_ERROR_SR_DOCUMENT_SUBTYPE,
  UPDATE_SR_DOCUMENT_SUBTYPE,
  CREATE_SR_DOCUMENT_SUBTYPE,
} from 'actions/types'
import _ from 'lodash'
import moment from 'moment'
import { filterByType } from 'utils/commonUtils'
import { selectObject } from 'utils/formUtils'

const INITIAL_STATE = {
  lastAction: null,
  subtypesAvailable: {},
  subtypeOptions: [],
  subtypeErrors: {},
}

const srDocumentSubtypeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_SR_DOCUMENT_SUBTYPES:
      return {
        ...state,
        lastAction: 'fetch',
        subtypesAvailable: _.mapKeys(action.payload, 'id'),
      }
    case SET_SR_DOCUMENT_SUBTYPE_OPTIONS:
      const options = selectObject(
        filterByType(action.payload, action.currentSrDocumentTypeId),
        action.currentSrDocumentSubtype
          ? action.currentSrDocumentSubtype.id
          : 0,
        true
      )
      return { ...state, subtypeOptions: options }
    case UNSET_SR_DOCUMENT_SUBTYPE_OPTIONS:
      if (state.subtypeOptions) {
        return { ...state, subtypeOptions: [] }
      }
      return state
    case UNSET_SR_DOCUMENT_SUBTYPE_ACTION:
      return { ...state, lastAction: null }
    case CREATE_SR_DOCUMENT_SUBTYPE:
      const createdItem = action.payload.created_items[0]
      const { id } = createdItem
      const newState = {
        ...state,
        lastAction: 'create',
        subtypesAvailable: {
          ...state.subtypesAvailable,
          [id]: createdItem,
        },
      }
      return newState
    case UPDATE_SR_DOCUMENT_SUBTYPE:
      const updatedItem = (state.subtypesAvailable[
        action.currentSrDocumentSubtype.id
      ] = action.currentSrDocumentSubtype)
      updatedItem.updated_at = moment.utc().format('YYYY-MM-DD HH:mm:ss')
      return {
        ...state,
        lastAction: 'edit',
        updatedItem,
      }
    case ERROR_SR_DOCUMENT_SUBTYPE:
      return {
        ...state,
        subtypeErrors: action.payload,
        lastAction: 'error',
      }
    case UNSET_ERROR_SR_DOCUMENT_SUBTYPE:
      return {
        ...state,
        subtypeErrors: {},
      }
    case TOGGLE_SR_DOCUMENT_SUBTYPE:
      const toggledItem = (state.subtypesAvailable[
        action.currentSrDocumentSubtype.id
      ] = action.currentSrDocumentSubtype)
      toggledItem.is_available = action.payload.toggle
      return {
        ...state,
        lastAction: action.payload.toggle ? 'enable' : 'disable',
        toggledItem,
      }
    case DELETE_SR_DOCUMENT_SUBTYPE:
      const updated = state.subtypesAvailable
      _.unset(updated, `${action.currentSrDocumentSubtype.id}`)
      return { ...state, lastAction: 'delete', subtypesAvailable: updated }
    default:
      return state
  }
}

export default srDocumentSubtypeReducer
